import { Modal } from "react-bootstrap";
import $ from "jquery";
import { useState } from "react";
import { togglePlanSection } from "../../../../../actions/show_modal_Action";
import { useDispatch } from "react-redux";
import { baseUrl } from "../../../../../utils";

const ProfanityUpgrade = ({ showProfanity, closeProfanity }) => {
  const [customPost, setCustomPost] = useState(null);
  const dispatch = useDispatch();

  const onUpgradeClick = (e) => {
    setTimeout(() => {
      setCustomPost(null);
      dispatch(togglePlanSection(true));
      closeProfanity();
    }, 100);

    $("#morePopupId").hide();
  };
  return (
    <Modal
      size="lg"
      dialogClassName=" modal-dialog-centered modal-overflow personalizePopupModal dynamic-popup"
      show={showProfanity}
      onHide={closeProfanity}
      centered
    >
      <Modal.Header
        className="justify-content-end personalize_wt"
        closeButton
      ></Modal.Header>

      <Modal.Body>
        <div className="p-8">
          <div className="pb-8 text-center">
            <div className="Errorimage mb-10">
              <img
                className="img-fluid"
                src={baseUrl(`error/permission-error.svg`)}
                alt={"Upgrade Plan"}
              />
            </div>

            <h3 className="text-center mb-5 ErrorMsg">
              Unable to use Profanity filter?
            </h3>
            <p className="font-weight-bold text-dark-75 text-center msgSec">
              Oops! Looks like you need to upgrade your plan in order to use
              Profanity filter
            </p>

            <div className="buttonUpgred mb-sm-5 mb-3">
              <a
                id="addonFeaturesScroll"
                onClick={(e) => onUpgradeClick()}
                className="commanBtn btn btn-primary px-5 d-inline-block"
              >
                Upgrade Plan
              </a>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ProfanityUpgrade;
